import React, {  useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import './Signup.sass';
import SignupStepper from "./SignupStepper";
import MobilePagination from "../../components/MobilePagination/MobilePagination";
import { shouldUseOptIn } from "../../basedata/constants";
import { useStep } from "../../context/StepContext"

const Signup = () => {
    const { t } = useTranslation();
    const { setStep } = useStep();
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
      setStep(1);
      if(shouldUseOptIn()){
        const _optin = sessionStorage.getItem("user_optin");
        if (!_optin) {
          navigate("/opt-in");
        }
      }

      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);

      return () => {
          window.removeEventListener("resize", handleResize);
      };



    }, [navigate]);

    const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5", "Step 6"];

    const nextStep = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevStep) => prevStep + 1);
        }
    };

    const prevStep = () => {
        if (activeStep > 0) {
            setActiveStep((prevStep) => prevStep - 1);
        }
    };

    const handleNameChange = (name: string) => {
        if (name && name.trim() !== '') {
            localStorage.setItem('name', name.trim());
        }
    };
    return (
      <div className="singup-card">
          <SignupStepper
              activeStep={activeStep}
              nextStep={nextStep}
              prevStep={prevStep}
          />
      </div>
    );
};

export default Signup;
